/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable default-case */
import { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import NavbarTopAdmin from './components/navbarTopAdmin'
import NavbarBottomAdmin from './components/navbarBottomAdmin'
import AuthProvider from '../Authentication/authProvider'
import { RotatingLines } from "react-loader-spinner"

function HomeAdmin() {
    const navigate = useNavigate()
    const [eventi, setEventi] = useState([])
    const [eventiImmutabile, setEventiImmutabile] = useState([])
    const [datiEvt, setDatiEvt] = useState({})//object evento in dettagli
    const [expired2, setExpired2] = useState({ color: 'black' })//color red if data event expired
    const [foto, setFoto] = useState([])
    const [opzioniEvento, setOpzioniEvento] = useState()
    const [msgProgress, setMsgProgress] = useState({ loader: 'grey', string: null, failed: null })//barra del loader dopo delete event
    const [titolo, setTitolo] = useState('Tutti gli eventi')
    const [dimensione, setDimensione] = useState(null)
    const [incorpora, setIncorpora] = useState(null)
    const [eventChecked, setEventChecked] = useState({ id: [], img: [], vid: [], error: false })
    const [cercaEvento, setCercaEvento] = useState([])

    const divDettagli = useRef()
    const confirmElimina = useRef()
    const descrizione = useRef()

    const details = { display: 'grid', gridTemplateColumns: '0.3fr 1fr', gap: '5px' }
    const today = new Date()
    today.setDate(today.getDate() - 1)
    const tomorrow = new Date(today).toISOString()

    const dettagli = async (e) => {
        setDatiEvt(e)
        setFoto(null); setOpzioniEvento(null)
        if (e.video) {
            axios.get(`/video-size/${e.video}`).then(res => { setDimensione(res.data.sizeMB) })
        }
        divDettagli.current.style.top = '0'

        if (e.img) {//se nell'evento ci sono foto...
            const img = e.img.split(',')//creo un array con il nome delle foto 
            setFoto(img)
        }
        e.dataFine < today ? setExpired2({ color: 'red' }) : setExpired2({ color: 'black' })
        if (e.opzioniEvento) {
            let stringa = ''
            e.opzioniEvento.split(',').forEach((elem, index) => {
                switch (elem) {
                    case "artisti": stringa += 'Artisti di strada, '; break
                    case "truccabimbi": stringa += 'Truccabimbi, '; break
                    case "parcheggio": stringa += 'Parcheggio gratuito, '; break
                    case "navetta": stringa += 'Navetta, '; break
                    case "mercatini": stringa += 'Mercatini, '; break
                    case 'fiera': stringa += 'Fiera espositiva, '; break
                    case "standGastronomici": stringa += 'Stand Gastronomici, '; break
                    case "streetFood": stringa += 'Street Food, '; break
                    case "areaTavoli": stringa += 'Area tavoli, '; break
                    case "birraArtigianale": stringa += 'Birra artigianale, '; break
                    case "musica": stringa += 'Musica Live, '; break
                    case "djSet": stringa += 'Dj set,  '; break
                    case "centroStorico": stringa += 'Centro storico visitabile, '; break
                    case "addobbi": stringa += 'Addobbi scenografici, '; break
                    case "attrazioniBambini": stringa += 'Attrazioni per bambini, '; break
                    case "liscio": stringa += 'Ballo liscio, '; break
                    case "gruppo": stringa += 'Balli di gruppo, '; break
                    case "scuolaDiBallo": stringa += 'Scuola di ballo '; break
                    default:
                }
            }); setOpzioniEvento(stringa)
        }
        if (e.incorporaUrl) {
            const url = e.incorporaUrl
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
            const match = url.match(regExp)//ricavo l'ID di 11 cifre dall'URL del video in youtube
            setIncorpora(match[2])
        }
        if (descrizione.current) descrizione.current.innerHTML = e.descrizione
    }
    const approva = (stato, img, video) => {
        if (stato === 'delete') {
            setMsgProgress({ string: 'Caricamento in corso...' })
            if (img) axios.delete(`/delete-img/${img}`, { data: { folder: '' } })

            if (video) axios.delete(`/delete-video/${video}`)
        }
        try {
            axios.post(`/approvaEvento/${parseInt(datiEvt.id)}/${datiEvt.email}/${stato}/${datiEvt.userId}/${datiEvt.titolo}`).then(res => {
                divDettagli.current.style.width = '0px'
                divDettagli.current.style.left = '-20%'
                setTimeout(() => { window.location.reload() }, 2000)
            })
        } catch (err) { console.log(err) }
    }
    const vetrina = (stato) => {
        try {
            axios.post(`/vetrina/${datiEvt.id}/${stato}`).then(res => {
                divDettagli.current.style.width = '0px'
                divDettagli.current.style.left = '-20%'
                setTimeout(() => { window.location.reload() }, 700)
            })
        } catch (err) { console.log(err) }
    }
    const fetchEventi = async () => {
        try {
            const res = await axios.get('/getEventi/dataInizio')
            setEventiImmutabile(res.data)
            setEventi(res.data)
        }
        catch (err) { console.log(err) }
    }
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value
        const we = eventi.filter(x => x.id === parseInt(name, 10))[0]
        let wim = ''; let wvi = ''
        if (we.img) wim = we.img; if (we.video) wvi = we.video

        inputValue === true && setEventChecked({
            img: eventChecked.img.concat(wim),
            vid: eventChecked.vid.concat(wvi),
            id: eventChecked.id.concat(name),
            error: false
        })

        inputValue === false && setEventChecked({
            img: eventChecked.img.filter(elem => elem !== wim),
            vid: eventChecked.vid.filter(elem => elem !== wvi),
            id: eventChecked.id.filter(elem => elem !== name),
            error: false
        })
    }
    const actionEvent = async (e) => {
        setEventChecked({ ...eventChecked, error: false })
        if (e === 'elimina') {
            const imgFiltrato = eventChecked.img.filter(elemento => elemento !== '')
            if (imgFiltrato.length !== 0) {
                const arr = imgFiltrato.join(',')//da array a stringa
                axios.delete(`/delete-img/${arr}`, { data: { folder: '' } })
            }
            const vidFiltrato = eventChecked.vid.filter(elemento => elemento !== '')
            if (vidFiltrato.length !== 0) {
                vidFiltrato.forEach(elem => {
                    axios.delete(`/delete-video/${elem}`)
                })
            }
        }
        const res = await axios.post(`/deleteEventi/${e}`, eventChecked.id)
        if (res.data === 'success') {
            window.location.reload()
        } else setEventChecked({ ...eventChecked, error: true })
    }
    const handleInputCerca = (e) => {
        const { value } = e.target
        let xc = []
        if (value)
            xc = eventi.filter(x => x.titolo.toLowerCase().includes(value.toLowerCase()))
        setCercaEvento(xc)
    }
    useEffect(() => {
        if (!localStorage.getItem('logged') && localStorage.getItem('email') !== 'maladmin@admin.it') {
            navigate('/', { replace: true })
        }
        fetchEventi()
    }, [])
    // useEffect(() => { console.log('eventi:', eventi) }, [eventi])

    return (<>
        <NavbarTopAdmin />
        <NavbarBottomAdmin />
        <AuthProvider />
        <div style={{ margin: '5em 0 10rem 0' }}>
            <div className='mt-4' style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '5px', marginLeft: '1em' }}>
                <div>
                    <button onClick={() => {
                        setEventi(eventiImmutabile.filter(item => item.accettazione === 'false'))
                        setTitolo('Eventi da approvare')
                    }} className='btn btn-warning'>NoAccep
                    </button>
                </div>
                <div>
                    <button onClick={() => {
                        setEventi(eventiImmutabile.filter(item => item.accettazione === 'rejection'))
                        setTitolo('Eventi rifiutati')
                    }} className='btn btn-danger'>Reject
                    </button>
                </div>
                <div>
                    <button onClick={() => {
                        setEventi(eventiImmutabile.filter(item => item.accettazione === 'true'))
                        setTitolo('Eventi approvati')
                    }} className='btn btn-success'>Accept
                    </button>
                </div>
                <div>
                    <button onClick={() => {
                        setEventi(eventiImmutabile)
                        setTitolo('Tutti gli eventi')
                    }} className='btn btn-primary'>Tutti
                    </button>
                </div>
            </div>
            <div style={{ position: 'fixed', left: '90%', fontSize: 'x-large', cursor: 'pointer', zIndex: '1' }}
                onClick={() => { window.scrollTo({ top: 0 }) }}>⬆️</div>
            {/* ---------- INPUT CERCA EVENTO -------------- */}
            <div className='ms-3 mt-3'>
                <label>Titolo evento</label>
                <input type='text' name='titolo' onChange={handleInputCerca} style={{ width: '70%', margin: '0 10px' }} />
                {cercaEvento.length !== 0 &&
                    <div style={{ border: '1px solid gray', width: '80%', fontSize: 'small', margin: '1em 1em' }}>
                        {cercaEvento.map(elem => (
                            <div key={elem.id} style={{ padding: '3px 5px', borderBottom: '1px solid grey' }}>{elem.titolo}
                                <span className='float-end'>
                                    <span style={{ color: 'red', cursor: 'pointer' }} onClick={() => {
                                        navigate('/editEvento1', {
                                            state: { idEvento: elem.id }
                                        })
                                    }}>Edit
                                    </span>
                                    <span style={{ color: 'navy', cursor: 'pointer', marginLeft: '10px' }} onClick={() => {
                                        navigate(`/eventiDetails/${elem.id}`)
                                    }}>Details
                                    </span>
                                </span>
                            </div>
                        ))
                        }
                    </div>
                }
            </div>

            {eventi.length === 0 &&
                <div className='text-center mt-5'>
                    <RotatingLines strokeColor={msgProgress.loader} strokeWidth='5' animationDuration='5' width='26' />
                </div>
            }
            <p className='fs-4 text-center mt-3' style={{ color: 'navy' }}><b>{titolo}</b></p>
            <div style={{ position: 'relative' }}>
                <table className="table">
                    <thead>
                        <tr style={{ fontSize: 'small' }}>
                            <th></th>
                            <th className='titolo'>Evento</th>
                            <th></th>
                            <th>👇</th>
                            <th>vid</th>
                            <th>iniz</th>
                            <th>Edit</th>
                            <th className='thDesk'>Fine</th>
                            <th className='thDesk'>Tipologia</th>
                            <th className='thDesk'>Pr</th>
                            <th className='thDesk'>User</th>
                        </tr>
                    </thead>
                    <tbody>
                        {eventi.map(evento => {
                            let flag, opc; let flag2 = {}
                            switch (evento.accettazione) {
                                case 'true': flag = 'lawngreen'; break
                                case 'false': flag = 'orange'; break
                                case 'null': flag = 'black'; break
                                case 'rejection': flag = 'red'; break
                                default: flag = 'transparent'
                            }
                            switch (evento.vetrina) {
                                case 'inEvidenza': flag2 = { backgroundColor: 'yellow' }
                            }
                            if (evento.dataFine < tomorrow) { opc = '.3' } else opc = '1'
                            return (
                                <tr key={evento.id} id={"evento" + evento.id}
                                    style={{ fontSize: 'small', opacity: opc }}>
                                    <td><div style={{
                                        borderRadius: '50px',
                                        width: '5px',
                                        height: '5px',
                                        marginTop: '12px',
                                        backgroundColor: flag
                                    }}></div>
                                    </td>
                                    <td className='titolo' style={{ ...flag2, cursor: 'pointer' }} onClick={() => { dettagli(evento) }}>{evento.titolo}</td>
                                    <td>{evento.provincia}</td>
                                    <td>
                                        <input
                                            id={evento.id}
                                            className='imgCheckbox'
                                            name={evento.id}
                                            defaultChecked={false}
                                            type="checkbox"
                                            onChange={handleInputChange} />
                                    </td>
                                    <td>{evento.video ? <span><b>vid</b></span> : null}</td>
                                    <td style={{ width: '8em', fontSize: 'small' }}>{evento.dataInizio.split("-").reverse().join("-")}</td>
                                    <td style={{ color: 'red', cursor: 'pointer' }} onClick={() => { navigate('/editEvento1', { state: { idEvento: evento.id } }) }}>edit</td>
                                    <td className='thDesk'>{evento.dataFine.split("-").reverse().join("-")}</td>
                                    <td className='thDesk'>{evento.tipologia}</td>
                                    <td className='thDesk'>
                                        {evento.prezzo !== '0' && evento.prezzo !== 'vai al sito web' ?
                                            <span>€ {evento.prezzo}</span> :
                                            evento.prezzo === '0' ? <span>Gratis</span> :
                                                evento.prezzo === 'vai al sito web' ? <span>sito web</span> : null}
                                    </td>
                                    <td className='thDesk'>{evento.userId}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div >
        {
            eventChecked.id.length !== 0 &&
            <div style={{ position: 'fixed', left: '0', top: '5em', width: '100%', backgroundColor: 'whitesmoke', padding: '10px' }}>
                <button className='btn btn-danger' onClick={() => { actionEvent('elimina') }} style={{}}>
                    <b>ELIMINA</b>
                </button>
                <button className='btn btn-secondary ms-2' onClick={() => { actionEvent('-evidenza') }} style={{}}>
                    <b>-EVIDENZA</b>
                </button>
                <button className='btn btn-warning ms-2' onClick={() => { actionEvent('+evidenza') }} style={{}}>
                    <b>+EVIDENZA</b>
                </button>
                {eventChecked.error &&
                    <p className='text-danger'>*** Problemi con il server ***</p>
                }
            </div>
        }

        {/* ---------- BANNER DETTAGLI ----------- */}
        <div className='visualDettagli' ref={divDettagli}>
            <img src={require("../userNotAuth/image/icons8-chiudi-macos-32.png")} width={40}
                style={{ float: 'right', cursor: 'pointer', position: 'sticky', top: '0' }} onClick={() => {
                    divDettagli.current.style.top = '120%'; setIncorpora(null)
                }} />
            <br />

            {datiEvt.id &&
                <div>
                    <h4>
                        {datiEvt.accettazione === 'true' && <span style={{ color: 'mediumseagreen' }}>Evento approvato</span>}
                        {datiEvt.accettazione === 'false' && <span style={{ color: 'orangered' }}>Evento da approvare</span>}
                        {datiEvt.accettazione === 'null' && <span style={{ color: 'black' }}>Evento annullato da user</span>}
                        {datiEvt.accettazione === 'rejection' && <span style={{ color: 'red' }}>Evento rifiutato</span>}
                        {datiEvt.vetrina === 'inEvidenza' && <p style={{ color: 'chartreuse' }}>Evento in evidenza</p>}
                    </h4> <hr />
                    <div style={details}>
                        <div>User Id:</div><div>{datiEvt.userId}</div>
                        <div>Email us:</div><div>{datiEvt.emailUser}</div>
                        <div>Titolo:</div><div>{datiEvt.titolo}</div>
                    </div>
                    {datiEvt.sottotitolo &&
                        <div className='mt-3'>
                            <div>SottoTitolo:</div>
                            <div style={{ border: '1px solid lightgrey', padding: '5px', marginBottom: '15px', borderRadius: '5px' }}>
                                <i>{datiEvt.sottotitolo}</i>
                            </div>
                        </div>
                    }
                    <div style={details}>
                        <div>Tipologia:</div><div>{datiEvt.tipologia}</div>
                        <div>Regione:</div><div>{datiEvt.regione}</div>
                        <div>Città:</div><div>{datiEvt.città}</div>
                        <div>Comune:</div><div>{datiEvt.comune}</div>
                        <div>Prezzo:</div><div>
                            {datiEvt.prezzo !== '0' && datiEvt.prezzo !== 'vai al sito web' ?
                                <span>€ {datiEvt.prezzo}</span> :
                                datiEvt.prezzo === '0' ? <span>Ingresso gratuito</span> :
                                    datiEvt.prezzo === 'vai al sito web' ? <span>Nel sito web</span> : null
                            }
                        </div>
                    </div>
                    {datiEvt.opzioniBiglietto &&
                        <div style={details}>
                            <div>Opz prz:</div><div>{datiEvt.opzioniBiglietto}</div>
                        </div>
                    }
                    <div style={details}>
                        <div>Inizio:</div><div style={expired2}>{datiEvt.dataInizio.split("-").reverse().join("-")}
                            <i> alle </i>{datiEvt.oraInizio ? datiEvt.oraInizio : '--'}
                        </div>
                        <div>Fine:</div><div>{datiEvt.dataFine.split("-").reverse().join("-")}
                            <i> alle </i>{datiEvt.oraFine ? datiEvt.oraFine : '--'}
                        </div>
                        <div>Creato il: </div><div>{datiEvt.created_at.split("-").reverse().join("-")}</div>
                        <div>Id evento: </div><div>{datiEvt.id}</div>
                    </div><hr />
                    {/*---------------- DESCRIZIONE ----------- */}
                    <p ref={descrizione} className='mt-3'></p>

                    {datiEvt.ospiti &&
                        <div className='mt-3'>OSPITI:
                            <span style={{ marginLeft: '5px' }}>{datiEvt.ospiti}</span>
                        </div>
                    }

                    {opzioniEvento &&
                        <div>
                            <h5 className='mt-3'>OPZIONI EVENTO:</h5>
                            {opzioniEvento}
                        </div>
                    }

                    <h5 className='mt-4'>INFO ORGANIZZATORE</h5>
                    <div style={details}>
                        <div>Email org:</div><div>{datiEvt.email}</div>
                    </div>
                    {datiEvt.telefono &&
                        <div style={details}>
                            <div>Telefono:</div><div>{datiEvt.telefono}</div>
                        </div>
                    }
                    {datiEvt.infoOrganizzatore &&
                        <div style={details}>
                            <div>Info org:</div><div>{datiEvt.infoOrganizzatore}</div>
                        </div>
                    }
                    {/* ------------------------ LINK ------------------------ */}
                    <div style={{ border: '1px solid lightgrey', borderRadius: '20px', padding: '15px 5px', marginTop: '2rem' }}>
                        <h5 style={{ fontFamily: 'sans-serif' }}>LINK</h5>
                        {datiEvt.url &&
                            <div className='btn btn-warning'>
                                <a href={datiEvt.url} style={{ textDecoration: 'none', color: 'navy' }} target='_blank'>Sito web</a>
                            </div>
                        }
                        {datiEvt.fb &&
                            <a href={datiEvt.fb} style={{ textDecoration: 'none', color: 'white', fontSize: 'x-large' }} target='_blank'>
                                <img className='ms-1' src={require('../userNotAuth/image/icons8-fb-48.png')} alt='' width={40} />
                            </a>
                        }
                        {datiEvt.youTube &&
                            <a href={datiEvt.youTube} style={{ textDecoration: 'none', color: 'white' }} target='_blank'>
                                <img className='ms-1' src={require('../userNotAuth/image/icons8-instagram-48.png')} alt='' width={40} />
                            </a>
                        }
                        {!datiEvt.url && !datiEvt.fb && !datiEvt.youTube && <span><i>nessun Link</i></span>}
                    </div>

                    {foto &&
                        <div><hr />
                            <h2>IMMAGINI CARICATE</h2>
                            {foto.map((elem, index) => (
                                <span key={index} style={{ marginRight: '3px' }}>
                                    <img src={`https://leuro-bucket.s3.amazonaws.com/${elem}`}
                                        style={{ border: '1px solid white', maxWidth: '100px', height: '74px' }} />
                                </span>))}
                        </div>
                    }

                    {datiEvt.video &&
                        <div><hr />
                            <h2>VIDEO CARICATO</h2>
                            <span style={{ marginRight: '3px' }}>
                                <video src={`https://leuro-bucket.s3.amazonaws.com/video/${datiEvt.video}`}
                                    style={{ border: '1px solid white', width: '60%', maxHeight: '200px' }} controls />
                                <p><b>{dimensione} MB</b> <br />{datiEvt.video}</p>
                            </span>
                        </div>
                    }
                    {/* ---------------------- INCORPORA VIDEO -------------------- */}
                    {incorpora && datiEvt.incorporaUrl &&
                        <iframe className='mt-3'
                            src={`https://www.youtube.com/embed/${incorpora}?si=nI26l5QmqMrpYujf`}
                            style={{ width: '100%', height: '350px' }}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="YouTube Video Player"
                        />
                    }
                    <hr style={{ border: '3px solid black' }} /><br />

                    <div>
                        {msgProgress.string &&
                            <span style={{ fontSize: 'large', color: 'navy', fontWeight: '700' }}>
                                <span style={{ marginLeft: '1rem' }}>{msgProgress.string}</span>
                                <RotatingLines strokeColor={msgProgress.loader} strokeWidth='5' animationDuration='5' width='26' />
                            </span>
                        }
                        <button className='btn btn-success' onClick={() => { approva(true) }}
                            style={{ float: 'left' }}>
                            Approva
                        </button>

                        <button onClick={() => { vetrina(datiEvt.vetrina) }}
                            style={{ marginLeft: '12%' }}>
                            {datiEvt.vetrina === 'inEvidenza' ? <span>Togli Evidenza</span> : <span>In Evidenza</span>}

                        </button>

                        <button className='btn btn-danger' style={{ float: 'right' }}
                            onClick={() => { confirmElimina.current.style.display = 'block' }}>
                            Elimina
                        </button>
                    </div><br />
                    <div className='mt-5'>
                        <button className='btn btn-warning' style={{ clear: 'left', float: 'left' }}
                            onClick={() => { approva(null) }}>
                            Rifiuta
                        </button>

                        <button style={{ marginLeft: ' 13% ' }}
                            onClick={() => {
                                navigate('/editEvento1', {
                                    replace: true, state: { idEvento: datiEvt.id }//per gestire le foto se provengo da 'addEvento2'
                                })
                            }}>
                            Modifica
                        </button>

                        <button className='btn btn-dark' style={{ clear: 'right', float: 'right' }}
                            onClick={() => { approva('annulla') }}>
                            Annulla
                        </button>
                    </div><br /><br /><br /><br />
                </div>
            }
        </div>

        {/* -------------------- BANNER ELIMINA DEFINITIVAMENTE L'EVENTO ----------------------- */}
        <div ref={confirmElimina} style={{
            display: 'none', position: 'fixed', backgroundColor: 'gainsboro', top: '30%', left: '0', right: '0', margin: 'auto',
            width: '80%', height: '40%', padding: '1rem', zIndex: '1', borderRadius: '10px', border: '1px solid grey', textAlign: 'center'
        }}>
            ELIMINARE DEFINITIVAMENTE '<i>{datiEvt.titolo}'</i> ?
            <div style={{ textAlign: 'center', marginTop: '8em' }} >
                <button className='float-start btn btn-success'
                    onClick={() => { confirmElimina.current.style.display = 'none' }}>Annulla
                </button>
                <button className='float-end btn btn-danger'
                    onClick={() => {
                        confirmElimina.current.style.display = 'none'
                        approva('delete', datiEvt.img, datiEvt.video)
                    }}>Elimina
                </button>
            </div>
        </div>
    </>
    )
}
export default HomeAdmin